import { defineStore } from 'pinia';
import httpClient from '../http-client.js';
import { dashboardApiEndpointConsts } from '../constants.js'

export const useShopStore = defineStore('shop', {
    state: () => ({
        shops: [],
        zipCode: ''
    }),
    persist: true,
    getters: {
    },
    actions: {
        fetchShopsAsync(args) {
            const payload = {
                ProviderName: args.providerName,
                ProviderPhone: args.providerPhone,
                ServiceZipCode: args.zipCode,
                Distance: args.distance,
                PageSize: args.numberOfResults,
                AccountNum: args.accountNum,
                CountryCode: "US",
                IsSafeliteProgramAccount: 0 // TODO hardcoded for state farm
            }
            return httpClient.callHttpClient({
                method: 'POST',
                endpoint: dashboardApiEndpointConsts.SPECIFIC_SHOP_SEARCH,
                payload: payload
            }).then((response) => {
                // Trim any trailing spaces from string values in each shop object
                this.shops = response.data.map(shop =>
                    Object.fromEntries(
                        Object.entries(shop).map(([key, value]) =>
                            [key, typeof value === 'string' ? value.trimEnd() : value]
                        )
                    )
                );
                this.zipCode = args.zipCode;
                return response;
            });
        },
        getClosestProgramProviders(args) {
            return httpClient.callHttpClient({
                method: 'GET',
                endpoint: dashboardApiEndpointConsts.GET_CLOSEST_PROGRAM_PROVIDERS + "?zipCode=" + args.zipCode,
            }).then((response) => {
                this.zipCode = args.zipCode;
                return response.data;
            });
        },
        clearStore() {
            this.shops = [];
            this.zipCode = '';
        }
    }
});